import React from 'react';
import PropTypes from 'prop-types';

import styles from '../../../ProductDetail/ProductDetail.module.css';

const CollapsibleSection = React.forwardRef((props, ref) => {
  const { isCollapsible, isOpen, toggleIsOpen, children, title } = props;
  const icon = isOpen ? 'fal fa-minus' : 'fal fa-plus';

  return (
    <div className={styles.details} ref={ref}>
      <div
        className={styles.header}
        style={{ alignItems: !title ? 'flex-start' : 'center' }}
      >
        {title}
        {isCollapsible && (
          <button type="button" className="naked-button" onClick={toggleIsOpen}>
            <i className={icon} />
          </button>
        )}
      </div>
      {(!isCollapsible || isOpen) && children}
    </div>
  );
});

CollapsibleSection.propTypes = {
  isCollapsible: PropTypes.bool,
  title: PropTypes.node,
  isOpen: PropTypes.bool.isRequired,
  toggleIsOpen: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

CollapsibleSection.defaultProps = {
  isCollapsible: true,
  title: '',
};

export default CollapsibleSection;
